import { CurrentTopicsQuery } from 'capability-ng-todos';
import * as _4 from 'lodash4';

export interface ITopic {
  id: number;
  has_opted_in: boolean;
  rank: number;
  name: string;
}
export class PathPreferencesController {
  private flags: {
    hasTopics: boolean;
  };

  private models: {
    loginConfig: any;
    topics: CurrentTopicsQuery;
  };

  constructor(
    private $state: any,
    private loginConfigModel: any,
    private ngCurrentTopicsQuery: CurrentTopicsQuery
  ) {}

  $onInit() {
    this.models = {
      loginConfig: this.loginConfigModel,
      topics: this.ngCurrentTopicsQuery
    };

    this.flags = {
      hasTopics: !_4.isEmpty(this.models.topics)
    };
  }

  resetPathPereferences(resetReason: string) {
    if (resetReason !== 'cancel') {
      this.$state.__goToPrevious__();
    }
  }
}

export class PathPreferencesComponent implements angular.IComponentOptions {
  public templateUrl: string = 'lib/my_settings/components/path_preferences/path_preferences.html';
  public controller: any = PathPreferencesController;
  public bindings: any = { allTopics: '<' };
}



// WEBPACK FOOTER //
// ./app/lib/my_settings/components/path_preferences/path_preferences.ts